import React, {useEffect, useState} from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import { formatDate } from "../../services/util";
import moment from "moment";
import { withDefaultReportParams } from "../Xero/Reports/hooks/useDefaultReportParams";
import { Line, HorizontalBar, Bar, Doughnut, Pie, Radar, Polar, Bubble, Scatter } from 'react-chartjs-2';
import MainCard from './MainCard';
import { Trans, useTranslation } from "react-i18next";

export const BankSummary = ({ data, item, setState, handleSubmit }) => {

  const { t } = useTranslation()

    const section = data.Rows.find(row => row.RowType === 'Section');

    const getSummaryCellValue = (data, k, n) => {
        if (section && section.Rows.length > 0) {
          const summaryRow = section.Rows[k];
      
          if (summaryRow && summaryRow.Cells) {
            return summaryRow.Cells[n]?.Value;
          }
        }
      
        return undefined;
      };
      
const shuffleArray = (array) => {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };
  
  const getRandomIndexes = () => {
    const numIndexes = Math.min(8, section.Rows.length);
    const allIndexes = Array.from({ length: section.Rows.length }, (_, index) => index);
    const shuffledIndexes = shuffleArray(allIndexes.slice(0, -1)); 
    return shuffledIndexes.slice(0, numIndexes);
  };
  
  const randomIndexes = getRandomIndexes();
  console.log(randomIndexes, "numbers");
  const foundNums = Array.from({ length: 8 }, (_, i) => i + 1);

  const accountDetails = foundNums.map((num) => {
    const accountName = getSummaryCellValue(data, randomIndexes[num - 1], 0);
    const cashReceived = getSummaryCellValue(data, randomIndexes[num - 1], 2);
    const cashSpent = getSummaryCellValue(data, randomIndexes[num - 1], 3);
    const closingBalance = getSummaryCellValue(data, randomIndexes[num - 1], 4);
  
    return {
      accountName: accountName || undefined,
      cashReceived: cashReceived || undefined,
      cashSpent: cashSpent || undefined,
      closingBalance: closingBalance || undefined,
    };
  });
  
  console.log(accountDetails);
  
  const { 0: one, 1: two, 2: three, 3: four, 4: five, 5: six, 6: seven, 7: eight } = accountDetails;
  

const [bankBalanceChartData, setBankBalanceChartData] = useState({});

const cashDues = [
  one, two, three, four, five, six, seven, eight
]
  .map((item) => {
    if (item && item.cashReceived !== undefined && item.cashSpent !== undefined) {
      return parseFloat(item.cashReceived) - parseFloat(item.cashSpent);
    }
    return undefined;
  })
  .filter((item) => item !== undefined);

const filterData = (data) => data.filter(item => item.balance != null);
const filterCashData = (data) => data.filter(item => item.cashReceived && item.cashSpent != null);

const bankBalanceData = filterData([
    { id: 1, name: one.accountName, balance: one.closingBalance },
    { id: 2, name: two.accountName, balance: two.closingBalance },
    { id: 3, name: three.accountName, balance: three.closingBalance },
    { id: 4, name: four.accountName, balance: four.closingBalance },
    { id: 5, name: five.accountName, balance: five.closingBalance },
    { id: 6, name: six.accountName, balance: six.closingBalance },
    { id: 7, name: seven.accountName, balance: seven.closingBalance },
    { id: 8, name: eight.accountName, balance: eight.closingBalance },
  ]);

  const cashFlowData = filterCashData([
    { id: 1, name: one.accountName, cashSpent: one.cashSpent, cashReceived: one.cashReceived, cashDue: cashDues[0] },
    { id: 2, name: two.accountName, cashSpent: two.cashSpent, cashReceived: two.cashReceived, cashDue: cashDues[1] },
    { id: 3, name: three.accountName, cashSpent: three.cashSpent, cashReceived: three.cashReceived, cashDue: cashDues[2] },
    { id: 4, name: four.accountName, cashSpent: four.cashSpent, cashReceived: four.cashReceived, cashDue: cashDues[3] },
    { id: 5, name: five.accountName, cashSpent: five.cashSpent, cashReceived: five.cashReceived, cashDue: cashDues[4] },
    { id: 6, name: six.accountName, cashSpent: six.cashSpent, cashReceived: six.cashReceived, cashDue: cashDues[5] },
    { id: 7, name: seven.accountName, cashSpent: seven.cashSpent, cashReceived: seven.cashReceived, cashDue: cashDues[6] },
    { id: 8, name: eight.accountName, cashSpent: eight.cashSpent, cashReceived: eight.cashReceived, cashDue: cashDues[7] }
  ]);
  
  useEffect(() => {
    const bankBalanceChart = convertTableToChartData(bankBalanceData, 'name', 'balance', 'bar');
    setBankBalanceChartData(bankBalanceChart);

  }, []);



const convertTableToChartData = (tableData, labelKey, dataKey, chartType) => {
  const labels = tableData.map(item => item[labelKey]);
  const data = tableData.map(item => item[dataKey]);

  const commonDatasetProperties = {
    label: chartType === 'bubble' || chartType === 'scatter' ? t('Account Closing Balance') : t('Account Balance'),
    data: chartType === 'bubble' || chartType === 'scatter' ? data.map((balance, index) => ({ x: index + 1, y: balance })) : data,
    backgroundColor: chartType === 'doughnut' ? getRandomColors(tableData.length) : 'rgba(75,192,192,0.2)',
    borderColor: 'rgba(75,192,192,1)',
    borderWidth: 1,
  };

  return {
    labels,
    datasets: [commonDatasetProperties],
  };
};

const accountNames = cashFlowData.map((item) => item.name);
  const cashSpent = cashFlowData.map((item) => item.cashSpent);
  const cashReceived = cashFlowData.map((item) => item.cashReceived);
  const cashDue = cashFlowData.map((item) => item.cashDue);


  const cashFlowChart = {
    labels: accountNames,
    datasets: [
      {
        label: t('Cash In'),
        data: cashReceived,
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
      },
      {
        label: t('Cash Out'),
        data: cashSpent,
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
      },
      {
        label: t('Cash Remaining'),
        data: cashDue,
        backgroundColor: 'rgba(255, 205, 86, 0.7)',
      },
    ],
  };


  const getRandomColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, 0.6)`;
      colors.push(color);
    }
    return colors;
  };

    const yearWord = data.ReportTitles[2].split(' ').pop();
    console.log(yearWord);
  
    return (
    <Page title={t(data.ReportTitles[0])} translate={false}>
         <div>
            <LocalForm
                className="d-print-none"
                getDispatch={(dispatch) => setState({ dispatch })}
                onSubmit={handleSubmit}
                initialState={item}
            >
                <div className="d-flex align-items-center mb-3">
                <FormGroup label="From Date" className="mr-3 text-nowrap">
                    <DatePicker model=".fromDate" className="form-control" />
                </FormGroup>
                <FormGroup label="To Date" className="mr-3 text-nowrap">
                    <DatePicker model=".toDate" className="form-control" />
                </FormGroup>
                <FormGroup label="&nbsp;">
                    <SubmitButton size="sm" className="d-block">
                    Update
                    </SubmitButton>
                </FormGroup>
                </div>

                <div className='my-4' style={{ maxWidth: '1000px', gap: '20px' }}>
                    {/* Bank Balance */}
                    <MainCard linkTo="/reports/bank_summary">
                        <div className='my-4'>
                            <h4><Trans>Bank Balance of</Trans> {data.ReportTitles[1]}</h4>
                            <p><strong><Trans>For the Year of</Trans> {yearWord}{/*data.ReportTitles[2]*/}</strong></p>
                            <Bar data={bankBalanceChartData} options={{ maintainAspectRatio: true, responsive: true }} />
                        </div>
                    </MainCard>
                    {/* Cash Flow Summary */}
                    <MainCard linkTo="/reports/bank_summary">
                        <div className='my-4'>
                            <h4><Trans>Cash Flow Summary</Trans></h4>
                            <Bar data={cashFlowChart}  options={{ maintainAspectRatio: true, responsive: true }}/>
                        </div>
                    </MainCard>
                </div>
            </LocalForm>
        </div>
    </Page>
)};

const loadReport = (item, xero) =>
  xero.get("reports/BankSummary", {
    params: {
      extra_params: item
    }
  }).get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    fromDate: formatDate(moment().startOf("month")),
    toDate: formatDate(moment().endOf("month")),
  })),
  onMount(({ item, xero }) => () => {
    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(BankSummary);
